export default "__VITE_ASSET__Ncqj98Kt__"